<template>
  <section>
    <footer class="footer" id='footer'>
      <div class="baozhang">
        <div class="container footer_bg">

        </div>
      </div>
      <div class="container cont">
        <div class="lianxi">
          <div class="telnum" v-html="indexData.index_telephone_footer"></div>
          <div class="desc">周一至周五 10:00-19:00</div>
          <div class="mt10">
            <a :href="indexData.index_kefu" class="lxbtn" target="_blank">
              <i class="iconfont icon-weixin"></i> 联系客服
            </a>
          </div>
        </div>
        <div class="footerlink">
          <dl v-for="(item,index) in indexData.index_nav_bottom" :key="index">
            <dt>{{item.name}}</dt>
            <dd v-for="(item_i) in item._child" :key="item_i.id">
              <a :href="'/page/'+item_i.id+'.html'" target="_blank" >{{item_i.title}}</a>
            </dd>
          </dl>
        </div>
        <!-- <div class="qrbox">
           <a href="https://klwbgyp.tmall.com" class="flex" target="_blank">
             <img src="/static/images/tianmao.png" alt="" srcset="">
             <span>快力文天猫店</span>
           </a>
            <a href="https://mall.jd.com/index-614123.html" class="flex" target="_blank">
             <img src="/static/images/jindong.png" alt="" srcset="">
             <span>快力文京东店</span>
           </a>
            <a href="https://shop114892455.taobao.com" class="flex" target="_blank">
             <img src="/static/images/taobao.png" alt="" srcset="">
             <span>快力文淘宝店</span>
           </a>
        </div> -->
      </div>

      <div class="copy">
        <div class="container">
          <div class="link">
            <span v-for="(item,index) in indexData.index_link_bottom" :key="index">
              <a :href="item.url" target="_blank" >{{item.remark}}</a>
              {{index < indexData.index_link_bottom.length-1 ? "|" : ""}}
            </span>
          </div>
          <div class="mt10" v-html="indexData.index_copyright"></div>
        </div>
      </div>
      <div class="link_friend copy">
        <div class="container">
          <div class="link">
            <a :href="item.url" target="_blank" rel="noopener noreferrer" v-for="(item,index) in indexData.index_link_friend" :key='index'>
              {{item.remark}}
            </a>
          </div>
        </div>
      </div>
      <div class="index_link_safe copy">
        <div class="container">
          <div class="link">
            <a :href="item.url" target="_blank"  rel="noopener noreferrer" v-for="(item,index) in indexData.index_link_safe" :key='index'>
              <img :src="'https://www.quilimen.com/'+item.src" alt="" srcset="">
              <span>{{item.remark}}</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  </section>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      
    };
  },
  props: {
    indexData: Object
  },
  methods: {}
};
</script>
<style scoped lang='scss'>
.copy{
  img{
    max-width: 200px;max-height: 200px;
  }
 
}
 #footer a{
    color: #666;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue